"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const FormComponent_1 = __importDefault(require("./FormComponent"));
const pathHelpers_1 = require("./utils/pathHelpers");
const FormContexts_1 = require("./Contexts/FormContexts");
// Main renderer for the form elements
// Takes template and goes through in order to generate the form
const FormRenderer = props => {
    const { template, childMode, controlPathPrefix } = props;
    // the ordre management array is just the order of the components and whether or not they should be "contained"
    // It only when the template changes, so we should memoize it
    const orderManagementArray = react_1.useMemo(() => {
        // Components define all the form elements in the form
        const { order, components } = template || {};
        let orderOutsideGroup = [];
        let groupFound = false;
        const orderManagementArray = [];
        // Comparing the defined sort order of the form elements to the given list of form elements
        order &&
            order.forEach(sectionKey => {
                if (!components[sectionKey]) {
                    if (process.env.NODE_ENV === 'development') {
                        console.log('order specifies a key which does not exist');
                    }
                }
                else {
                    // Form elements outside of a group
                    if (components[sectionKey].type !== 'group') {
                        groupFound = false;
                        orderOutsideGroup.push(sectionKey);
                    }
                    else {
                        // Form elements inside of a group
                        groupFound = true;
                        orderManagementArray.push({
                            isContained: false,
                            order: orderOutsideGroup,
                        });
                        orderManagementArray.push({
                            isContained: true,
                            order: [sectionKey],
                        });
                        orderOutsideGroup = [];
                    }
                }
            });
        if (!groupFound) {
            orderManagementArray.push({
                isContained: false,
                order: orderOutsideGroup,
            });
        }
        return orderManagementArray;
    }, [template]);
    const { controlMap } = FormContexts_1.useControlProvider();
    const formTemplateRendererWithProp = react_1.useCallback((orderManagementOrder) => {
        // Rendered for every component that is not in a group, and then once per group
        return (orderManagementOrder &&
            orderManagementOrder.map((sectionKey, index) => {
                const component = template.components[sectionKey];
                const controlPath = pathHelpers_1.formattedPath(sectionKey, controlPathPrefix);
                // Form elements. Component is form element definition from gen5lib
                return react_1.default.createElement(FormComponent_1.default, { key: index, component: component, controlPath: controlPath });
            }));
    }, [controlPathPrefix, template.components]);
    return (react_1.default.createElement(react_1.default.Fragment, null, orderManagementArray.map((orderManagement, index) => (react_1.default.createElement(react_1.Fragment, { key: index }, !orderManagement.isContained && !childMode ? (react_1.default.createElement(controlMap.RootWrapper, null, formTemplateRendererWithProp(orderManagement.order))) : (
    // Elements inside the group. They don't need rootwrapper UI panel.
    formTemplateRendererWithProp(orderManagement.order)))))));
};
exports.default = react_1.default.memo(FormRenderer);
